export default __webpack_public_path__ + "static/media/stock4.605ef3e8.jpg";